import React from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { injectIntl } from 'react-intl';
import treeChanges from 'tree-changes';

import { Card, Collapse } from 'antd';
import CriteriaForm from './CriteriaForm';
import ReportTable from './ReportTable';

import StockReorderPlanningReportActions from '../../Stores/StockReorderPlanningReport/Actions';

const { Panel } = Collapse;

class StockReorderPlanningReportScreen extends React.PureComponent {
  componentDidMount() {
    const { curSiteFlowId, initStockReorderPlanning } = this.props;

    if (curSiteFlowId > 0) {
      initStockReorderPlanning();
    }
  }

  componentDidUpdate(prevProps) {
    const { curSiteFlowId, initStockReorderPlanning } = this.props;
    const { changed } = treeChanges(prevProps, this.props);

    if (changed('curSiteFlowId')) {
      if (curSiteFlowId > 0) {
        initStockReorderPlanning();
      }
    }
  }

  componentWillUnmount() {}

  render() {
    const { intl, match } = this.props;

    return (
      <Card title={intl.formatMessage({ id: 'stock_reorder_planning_report' })}>
        <Collapse defaultActiveKey={['2']}>
          <Panel header={intl.formatMessage({ id: 'criteria' })} key="1">
            <CriteriaForm match={match} />
          </Panel>
          <Panel header={intl.formatMessage({ id: 'report' })} key="2">
            <ReportTable match={match} />
          </Panel>
        </Collapse>
      </Card>
    );
  }
}

StockReorderPlanningReportScreen.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object,

  initStockReorderPlanning: PropTypes.func,
  curSiteFlowId: PropTypes.number
};

StockReorderPlanningReportScreen.defaultProps = {
  intl: {},
  match: {},

  initStockReorderPlanning: {},
  curSiteFlowId: 0
};

const mapStateToProps = state => ({
  curSiteFlowId: state.app.curSiteFlowId
});

const mapDispatchToProps = dispatch => ({
  initStockReorderPlanning: () =>
    dispatch(StockReorderPlanningReportActions.stockReorderPlanningReportInitStockReorderPlanning())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(StockReorderPlanningReportScreen));
